module.exports = __webpack_public_path__ + "src/assets/tabular_view_on.png";